import { create } from 'zustand';
import type { FieldIrSignal } from '@/(routers)/boards/editor/block/definitions/fields/fieldIrSignal';

interface BlockModalIrState {
    fieldRef: FieldIrSignal | null;
    setFieldRef: (ref: FieldIrSignal | null) => void;
    clearFieldRef: () => void;
}

export const useBlockModalIrStore = create<BlockModalIrState>((set) => ({
    fieldRef: null,
    setFieldRef: (ref) => set({ fieldRef: ref }),
    clearFieldRef: () => set({ fieldRef: null }),
}));
